import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule, MatButtonModule, MatDatepickerModule, MatSlideToggleModule, MatIconModule } from '@angular/material';
import { ExtractComponent } from './extract.component';
import { SharedModule } from './../../shared/shared.module';
import { MonthFilterComponent } from './month-filter/month-filter.component';
import { SlickModule } from 'ngx-slick';
import { ExtractService } from './extract.service';
import { ExtractTableComponent } from './extract-table/extract-table.component';
import { SpecialFilterComponent } from './special-filter/special-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		MatTableModule,
		SlickModule.forRoot(),
		MatDatepickerModule,
		MatButtonModule,
		FormsModule,
		ReactiveFormsModule,
		MatSlideToggleModule,
		MatIconModule
	],
	declarations: [
		ExtractComponent,
		MonthFilterComponent,
		ExtractTableComponent,
		SpecialFilterComponent
	],
	exports: [
		ExtractComponent,
		ExtractTableComponent
	],
	providers: [ExtractService]
})
export class ExtractModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/extract/extract.module.ts